import { render, staticRenderFns } from "./GBPhotoAlbumList.vue?vue&type=template&id=48b8210a&"
import script from "./GBPhotoAlbumList.vue?vue&type=script&lang=js&"
export * from "./GBPhotoAlbumList.vue?vue&type=script&lang=js&"
import style0 from "./GBPhotoAlbumList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/demo/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBtn,VCheckbox,VDataTable,VFlex,VIcon,VLayout,VProgressCircular,VSpacer})
